/**
 *
 * ActionPlanTaskForm
 *
 */

import React, { Fragment } from "react"
import "./index.less"
import { Input, Button, Popover, Checkbox, DatePicker, Select } from "antd"
import moment from "moment"
import SelectHR from "../Select"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import { validate } from "../../utils/functions"
import { loadTexts, sanitize } from "../../utils/i18n"
import { Form } from "@ant-design/compatible"

const FormItem = Form.Item
/* eslint-disable react/prefer-stateless-function */
class ActionPlanTaskForm extends React.Component {
  intl = loadTexts("dashboard")
  isNew = true
  state = {
    id_task: null,
    periodicity: 0,
    date_end: null,
    date_start: null,
    id_employee: null,
    name: "",
    task_schedules: [],
    loading_save: false,
  }

  componentDidMount = () => {

    const { data, defaultEmployee,modalActionPlanCreateIa } = this.props
    const modalActionPlanCreateIaValidate = modalActionPlanCreateIa ? modalActionPlanCreateIa : false
    data.id_employee = defaultEmployee
    if (data.name || modalActionPlanCreateIaValidate ) {
      this.isNew = false
      data.date_end = data.date_end ?  moment(data.date_end, ["YYYY-MM-DD", "DD/MM/YYYY"]):  null
      if (data.periodicity !== 0) {
        data.date_start = data.date_start ? moment(data.date_start, ["YYYY-MM-DD", "DD/MM/YYYY"]):  null
      }

      if (data.employees && data.employees.length > 0) {
        data.id_employee = data.employees[0].id_employee
      }
    }
    this.setState({ ...Object.assign(this.state, data) })
  }
  onUpdateActionPlan=(e) => {
    const tasksUpdate  = e.tasks.find(t => t.id_task === this.state.id_task)
    this.setState({ task_schedules: tasksUpdate.task_schedules })
   // this.props.onReloadActionPlan(e)
  }
  updateTaskStatus = async (type = 1, dataTask, done = 1) => {
    done = done ? 1 : 0
    //if(this.isNew || !dataTask.hasOwnProperty('id_task_schedule') || !dataTask.id_task_schedule){
      this.setState(prevState => {
        const updatedTaskSchedules = prevState.task_schedules.map(task => {
            if (task.task_date === dataTask.task_date) {
                return { ...task, done: done };
            }
            return task;
        });
        return { task_schedules: updatedTaskSchedules };
    });
    return;

    /* let url = `tasks/${dataTask.id_task_schedule}/done`
    if (type === 2) {
      url = `tasks-schedules/${dataTask.id_task_schedule}/done`
    }
    try {
      const result = await fetchGlobalApi({
        method: "POST",
        endpoint: url,
        data: { done: done }
      })
      this.onUpdateActionPlan(result.data.data.result)
    } catch (error) {
      returnMessage(error)
    } */
  }
  calculatePeriodicity = () => {
    const { periodicity, date_end, date_start } = this.state
    if (!date_start) return
    const result = []
    const start = moment(date_start).startOf("day")
    // Fecha final de la tarea

    const end = moment(date_end).startOf("day")
    // Fecha inicio de la tarea

    const day = start.day() // Día de inicio de la tarea
    const current = start.clone()
    result.push(current.clone()) // Agregamos la primera fecha
    let add = 0
    if (periodicity === 1 || periodicity === 2) {
      add = periodicity === 1 ? 7 : 15 // se agrega 7 o 15.
      while (current.day(add + day).isBefore(end)) {
        result.push(current.clone())
      }
    }
    if (
      periodicity === 3 ||
      periodicity === 4 ||
      periodicity === 5 ||
      periodicity === 6
    ) {
      if (periodicity === 3) add = 1
      if (periodicity === 4) add = 3
      if (periodicity === 5) add = 6
      if (periodicity === 6) add = 12
      while (current.add(add, "M").isBefore(end)) {
        result.push(current.clone())
      }
    }

    const  task_schedules_state=this.state.task_schedules
    
    this.setState({
      task_schedules: result.map((m) => {
        const d = {}
        const task = task_schedules_state.find((t) =>  moment(t.task_date, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD") === moment(m, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("YYYY-MM-DD"))
        
        d.active_date_red = task ? task.active_date_red : false
        d.date_transform = m.format("YYYY-MM-DD")
        d.done = task ? task.done : false
        d.id_task = task ? task.id_task : null
        d.id_task_schedule = task ? task.id_task_schedule : null
        d.task_date = m.format("YYYY-MM-DD")
        return d
      }),
    })
  }

  changeEndDate = (endDate) => {
    const { date_start } = this.state
    this.setState({ date_end: endDate }, () => {
      if (date_start && moment(endDate).isBefore(date_start)) {
        this.setState({
          date_start: null,
          task_schedules: [],
        })
      } else {
        this.calculatePeriodicity()
      }
    })
  }

  onSave = async (toServer = false) => {
    woopraTrack("Guardar tarea")
    const { data, actionPlan, onFinishSave, collaborators } = this.props
    const params = JSON.parse(JSON.stringify(this.state))
    const isEditTask = !!data.id_task
    params.date_end = moment(params.date_end).format("Y-MM-DD")
    params.date_start = moment(params.date_start).format("Y-MM-DD")
    params.task_schedules = params.task_schedules.map((task) => {
      
      if (typeof task === "object") {
        return {
          task_date: moment(task.task_date, ["DD-MM-YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD"),
          done: task.done || false
        }
      }
      return task
    })
    delete params.loading_save
    if (!isEditTask) {
      delete params.id_task
    }
    if (params.periodicity === 0) {
      delete params.date_start
      delete params.task_schedules
    }
    if (toServer) {
      if (isEditTask) {
        params._method = "PUT"
      }
      this.setState({ loading_save: true })
      try {
        const url = !isEditTask
          ? `action-plans/${actionPlan.id_action_plan}/tasks`
          : `action-plans/${actionPlan.id_action_plan}/tasks/${params.id_task}`
        const save = await fetchGlobalApi({
          method: "POST",
          endpoint: url,
          data: params,
        })
        this.setState({ loading_save: false })
        returnMessage(save)
        onFinishSave(save.data.data.result)
      } catch (error) {
        this.setState({ loading_save: false })
        returnMessage(error)
      }
    } else {
      params.employees = [
        collaborators.find((c) => c.id_employee === this.state.id_employee),
      ]
      this.props.onFinishSave(params)
    }
  }

  setPeriodicity = (periodicity) => {
    this.calculatePeriodicity()
    this.setState({ periodicity }, () => this.calculatePeriodicity())
  }

  render() {
    const {
      periodicity,
      date_end,
      date_start,
      task_schedules,
      id_employee,
      name,
      loading_save,
    } = this.state

    const { style, collaborators, onCancel, actionPlan,data} = this.props

    const dateStartDatePicker =
      validate.exist(date_start) && !validate.empty(date_start)
        ? moment(date_start)
        : null
    const canChangeStatus =
    actionPlan.editable || validRole({ role: [1, 2, 3, 4,5] }) || data.editable
    const dateTask = (
      <Fragment>
        <div className="ActionPlanTasks-component-detail-next-dates-title">
          {this.intl.actionPlanTaskForm.taskScheduler}
        </div>
        <div
          className="ActionPlanTasks-component-detail-next-dates"
          style={{ maxHeight: 200, overflow: "auto" }}>
          {task_schedules.map((d, di) => (
            <Checkbox disabled={!canChangeStatus}  onClick={() =>
              this.updateTaskStatus(2, d, !d.done)
            } key={di} checked={d.done}>
              {d.task_date ? d.task_date.format("DD/MM/YYYY") : d}
            </Checkbox>
          ))}
        </div>
      </Fragment>
    )
    return (
      <div className="ActionPlanTasksForm-component" style={style}>
        <div>
          <span style={{ marginBottom: 5, display: "block" }}>
            {sanitize(this.intl.actionPlanTaskForm.labels.task)}
          </span>
          <FormItem>
          {(
          <Input
            placeholder={this.intl.actionPlanTaskForm.placeholder.task}
            onChange={(e) => this.setState({ name: e.target.value })}
            value={name}
            defaultValue={name}
            />)}
            </FormItem>
        </div>
        <div className="ActionPlanTasksForm-component-columns">
          <div>
            <label>{this.intl.actionPlanTaskForm.labels.endDate}*</label>
            <DatePicker
              format="DD/MM/YYYY"
              allowClear={false}
              disabledDate={(current) =>
                current && current < moment().startOf("day")
              }
              placeholder={this.intl.actionPlanTaskForm.placeholder.endDate}
              style={{ width: "100%" }}
              onChange={(e) => this.changeEndDate(e)}
              value={ date_end}
            />
          </div>
          <div>
            <label>{this.intl.actionPlanTaskForm.labels.periodicity}</label>
            <Select
              placeholder={this.intl.actionPlanTaskForm.placeholder.periodicity}
              value={periodicity}
              style={{ width: "100%" }}
              onChange={(e) => this.setPeriodicity(e)}>
              {this.intl.actionPlanTaskForm.periodicityOptions.map((p, pi) => (
                <Select.Option key={pi} value={pi}>
                  {" "}
                  {p}{" "}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div>
            <label>{this.intl.actionPlanTaskForm.labels.responsible}</label>
            <SelectHR
              onChange={(selectedEmployee) => {
                this.setState({ id_employee: selectedEmployee.id_employee })
              }}
              options={collaborators}
              labelKey="id_employee"
              labelImage="picture_profile"
              label="full_name"
              id="responsable"
              style={{ width: 300, marginBottom: 10 }}
              value={id_employee}
              placeholder={this.intl.actionPlanTaskForm.placeholder.responsible}
            />
          </div>
        </div>
        {periodicity != 0 && date_end && (
          <Fragment>
            <div>
              <div
                className="ModalACtionPlanCreate-component-view-content-columns-left-block-header"
                style={{ display: "grid" }}>
                <span style={{ width: 235, color: "#858585" }}>
                  {this.intl.actionPlanTaskForm.labels.periodicityConfig}
                </span>
              </div>
            </div>
            <div className="ActionPlanTasksForm-component-columns">
              <div>
                <label>
                  {this.intl.actionPlanTaskForm.labels.firstTaskDate}
                </label>
                <DatePicker
                  format="DD/MM/YYYY"
                  value={dateStartDatePicker}
                  allowClear={false}
                  placeholder={
                    this.intl.actionPlanTaskForm.placeholder.firstTaskDate
                  }
                  style={{ width: "100%" }}
                  disabledDate={(current) =>
                    current && current >= moment(date_end).startOf("day")
                  }
                  onChange={(e) =>
                    this.setState({ date_start: e }, () =>
                      this.calculatePeriodicity()
                    )
                  }
                />
              </div>
              <div>
                <label>{this.intl.actionPlanTaskForm.labels.countTasks}:</label>
                <Popover
                  placement="bottomLeft"
                  content={dateTask}
                  trigger="click">
                  <span
                    style={{
                      cursor: "pointer",
                      color: "#1890FF",
                      verticalAlign: "sub",
                    }}>
                    {task_schedules.length}{" "}
                    {plural(
                      this.intl.actionPlanTaskForm.labels.taskWord,
                      task_schedules.length,
                      "s"
                    )}
                  </span>
                </Popover>
              </div>
            </div>
          </Fragment>
        )}
        <div style={{ textAlign: "right" }}>
          <Button
            onClick={() => {
              woopraTrack("Cancelar agregar tarea")
              onCancel()
            }}>
            {this.intl.actionPlanTaskForm.actions.cancel}
          </Button>
          <Button
            type="primary"
            style={{ marginLeft: 10 }}
            onClick={() => this.onSave(!!actionPlan.id_action_plan)}
            loading={loading_save}
            disabled={
              !!(
                date_end === null ||
                id_employee === null ||
                name.length === 0 ||
                (periodicity !== 0 && task_schedules.length === 0) ||
                (periodicity !== 0 && date_start === null)
              )
            }>
            {this.isNew
              ? this.intl.actionPlanTaskForm.actions.add
              : this.intl.actionPlanTaskForm.actions.save}
          </Button>
        </div>
      </div>
    )
  }
}

ActionPlanTaskForm.propTypes = {}
ActionPlanTaskForm.defaultProps = {
  style: {},
  actionPlan: {},
  currentTask: {},
  onFinishSave: () => {},
  defaultEmployee: null,
  data: {},
}

export default ActionPlanTaskForm
